import React, { useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Badge,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import MenuButton from "./MenuButton";
import MenuBar from "./MenuBar";
function SubscriptionBilling() {
  const [showMenu, setShowMenu] = useState(false);

  const handleToggleClick = () => {
    setShowMenu(!showMenu);
  };

  return (
    <div>
      <MenuBar isOpen={showMenu} />
      <div className="content bg-white rounded-xl">
        <Tabs size={"lg"} className="">
          <div className="font-semibold text-3xl my-4 ml-2">
            Subscriptions & Billing
          </div>
          <button className="lg-hidden mb-4" onClick={handleToggleClick}>
            <MenuButton />
          </button>
          <TabList className="">
            <Tab>Subscriptions</Tab>
            <Tab>Billings</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <h2 className="text-lg font-semibold px-2 py-7">
                Purchase History
              </h2>
              <TableContainer>
                <Table size="sm">
                  <Thead>
                    <Tr>
                      <Th>Description</Th>
                      <Th>Created On</Th>
                      <Th>Status</Th>
                      <Th>Total</Th>
                      <Th>Actions</Th>
                      {/* <Th>...</Th> */}
                    </Tr>
                  </Thead>
                  <Tbody flex={"col"} gap={"100px"}>
                    <Tr>
                      <Td display={"flex"}>
                        <div className="flex">
                          <img
                            src="https://img.freepik.com/free-vector/gradient-gold-royal-crown_78370-1143.jpg?w=60&t=st=1715167557~exp=1715168157~hmac=22a43eb282e5d1fdd058cf3c73b91226593e1f255eb87862338df64f6dd9e3cb"
                            alt=""
                          />
                        </div>
                        <div className="ml-2.5 flex flex-col ">
                          <p className="text-base font-semibold text-black">
                            Subscription Purchase{" "}
                            <span className="text-green-500">(Active)</span>
                          </p>
                          <span className="text-sm opacity-80 ">
                            4455451-9554215
                          </span>
                        </div>
                      </Td>
                      <Td textColor={""} textDecoration={""}>
                        06 May
                      </Td>
                      <Td textColor={""} textDecoration={""}>
                        <Badge colorScheme="green">Paid</Badge>
                      </Td>
                      <Td>₹4000</Td>
                      <Td textColor={"purple"} textDecoration={"underline"}>
                        View Invoice
                      </Td>
                      <Td>
                        <div>
                          <i class="fa-solid fa-download text-lg"></i>
                        </div>
                      </Td>
                    </Tr>
                    <Tr>
                      <Td display={"flex"}>
                        <div className="flex">
                          <img
                            src="https://img.freepik.com/free-vector/gradient-gold-royal-crown_78370-1143.jpg?w=60&t=st=1715167557~exp=1715168157~hmac=22a43eb282e5d1fdd058cf3c73b91226593e1f255eb87862338df64f6dd9e3cb"
                            alt=""
                          />
                        </div>
                        <div className="ml-2.5 flex flex-col ">
                          <p className="text-base font-semibold text-black">
                            Subscription Purchase{" "}
                            <span className="text-green-500">(Active)</span>
                          </p>
                          <span className="text-sm opacity-80 ">
                            4455451-9554215
                          </span>
                        </div>
                      </Td>
                      <Td textColor={""} textDecoration={""}>
                        06 May
                      </Td>
                      <Td textColor={""} textDecoration={""}>
                        <Badge colorScheme="green">Paid</Badge>
                      </Td>
                      <Td>₹4000</Td>
                      <Td textColor={"purple"} textDecoration={"underline"}>
                        View Invoice
                      </Td>
                      <Td>
                        <div>
                          <i class="fa-solid fa-download text-lg"></i>
                        </div>
                      </Td>
                    </Tr>
                    <Tr>
                      <Td display={"flex"}>
                        <div className="flex">
                          <img
                            src="https://img.freepik.com/free-vector/gradient-gold-royal-crown_78370-1143.jpg?w=60&t=st=1715167557~exp=1715168157~hmac=22a43eb282e5d1fdd058cf3c73b91226593e1f255eb87862338df64f6dd9e3cb"
                            alt=""
                          />
                        </div>
                        <div className="ml-2.5 flex flex-col ">
                          <p className="text-base font-semibold text-black">
                            Subscription Purchase{" "}
                            <span className="text-green-500">(Active)</span>
                          </p>
                          <span className="text-sm opacity-80 ">
                            4455451-9554215
                          </span>
                        </div>
                      </Td>
                      <Td textColor={""} textDecoration={""}>
                        06 May
                      </Td>
                      <Td textColor={""} textDecoration={""}>
                        <Badge colorScheme="green">Paid</Badge>
                      </Td>
                      <Td>₹4000</Td>
                      <Td textColor={"purple"} textDecoration={"underline"}>
                        View Invoice
                      </Td>
                      <Td>
                        <div>
                          <i class="fa-solid fa-download text-lg"></i>
                        </div>
                      </Td>
                    </Tr>
                    <Tr>
                      <Td display={"flex"}>
                        <div className="flex">
                          <img
                            src="https://img.freepik.com/free-vector/gradient-gold-royal-crown_78370-1143.jpg?w=60&t=st=1715167557~exp=1715168157~hmac=22a43eb282e5d1fdd058cf3c73b91226593e1f255eb87862338df64f6dd9e3cb"
                            alt=""
                          />
                        </div>
                        <div className="ml-2.5 flex flex-col ">
                          <p className="text-base font-semibold text-black">
                            Subscription Purchase{" "}
                            <span className="text-green-500">(Active)</span>
                          </p>
                          <span className="text-sm opacity-80 ">
                            4455451-9554215
                          </span>
                        </div>
                      </Td>
                      <Td textColor={""} textDecoration={""}>
                        06 May
                      </Td>
                      <Td textColor={""} textDecoration={""}>
                        <Badge colorScheme="green">Paid</Badge>
                      </Td>
                      <Td>₹4000</Td>
                      <Td textColor={"purple"} textDecoration={"underline"}>
                        View Invoice
                      </Td>
                      <Td>
                        <div>
                          <i class="fa-solid fa-download text-lg"></i>
                        </div>
                      </Td>
                    </Tr>
                    <Tr>
                      <Td display={"flex"}>
                        <div className="flex">
                          <img
                            src="https://img.freepik.com/free-vector/gradient-gold-royal-crown_78370-1143.jpg?w=60&t=st=1715167557~exp=1715168157~hmac=22a43eb282e5d1fdd058cf3c73b91226593e1f255eb87862338df64f6dd9e3cb"
                            alt=""
                          />
                        </div>
                        <div className="ml-2.5 flex flex-col ">
                          <p className="text-base font-semibold text-black">
                            Subscription Purchase{" "}
                            <span className="text-green-500">(Active)</span>
                          </p>
                          <span className="text-sm opacity-80 ">
                            4455451-9554215
                          </span>
                        </div>
                      </Td>
                      <Td textColor={""} textDecoration={""}>
                        06 May
                      </Td>
                      <Td textColor={""} textDecoration={""}>
                        <Badge colorScheme="green">Paid</Badge>
                      </Td>
                      <Td>₹4000</Td>
                      <Td textColor={"purple"} textDecoration={"underline"}>
                        View Invoice
                      </Td>
                      <Td>
                        <div>
                          <i class="fa-solid fa-download text-lg"></i>
                        </div>
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>
            </TabPanel>
            <TabPanel>
              <div className="text-xl font-semibold px-2 py-7">
                Billing History
              </div>
              <TableContainer>
                <Table size="sm">
                  <Thead>
                    <Tr>
                      <Th justifySelf={"center"}>Date</Th>
                      <Th>Plan Details</Th>
                      <Th>Expires on</Th>
                      <Th>Amount</Th>
                      <Th>Status</Th>
                      <Th>Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody flex={"col"} gap={"100px"}>
                    <Tr>
                      <Td>
                        07 May, 2024 <br />
                        <div className="py-2 opacity-80">01:13 AM</div>
                      </Td>
                      <Td fontWeight={"semibold"}>Job Posting Plan</Td>
                      <Td></Td>
                      <Td>₹708</Td>
                      <Td>
                        <Badge colorScheme="red">Failed</Badge>
                      </Td>
                      <Td>Contact Us</Td>
                    </Tr>
                    <Tr>
                      <Td>
                        07 May, 2024 <br />
                        <div className="py-2 opacity-80">01:13 AM</div>
                      </Td>
                      <Td fontWeight={"semibold"}>Job Posting Plan</Td>
                      <Td></Td>
                      <Td>₹708</Td>
                      <Td>
                        <Badge colorScheme="red">Failed</Badge>
                      </Td>
                      <Td>Contact Us</Td>
                    </Tr>
                    <Tr>
                      <Td>
                        07 May, 2024 <br />
                        <div className="py-2 opacity-80">01:13 AM</div>
                      </Td>
                      <Td fontWeight={"semibold"}>Job Posting Plan</Td>
                      <Td></Td>
                      <Td>₹708</Td>
                      <Td>
                        <Badge colorScheme="red">Failed</Badge>
                      </Td>
                      <Td>Contact Us</Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </div>
  );
}

export default SubscriptionBilling;
